import script from "./VehicleDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDetailsPage.vue?vue&type=style&index=0&id=3e58541b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e58541b"]])

export default __exports__